export default function Support() {
  return (
    <section id="support" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <span className="text-[#00D9FF] text-sm font-semibold tracking-[0.2em] uppercase">SUPPORT</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1128]">We're here to help</h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              Our dedicated support team is available 24/7 to assist you with any questions or issues. Whether you need help with installation, troubleshooting, or understanding features, we're just a message away.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              Get instant answers from our comprehensive knowledge base or connect with our support team for personalized assistance.
            </p>
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer group">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-book-open-line text-3xl text-blue-600"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#0A1128] mb-3">Knowledge Base</h3>
                  <p className="text-gray-700 mb-4">
                    Browse our extensive library of guides, tutorials, and FAQs to find quick solutions.
                  </p>
                  <div className="flex items-center text-blue-600 font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                    Browse Articles
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer group ml-8">
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-customer-service-2-line text-3xl text-green-600"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-[#0A1128] mb-3">Live Chat</h3>
                  <p className="text-gray-700 mb-4">
                    Connect with our support team instantly for real-time assistance and personalized help.
                  </p>
                  <div className="flex items-center text-green-600 font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                    Start Chat
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
